<template>
  <header>
    <div class="header-title">
      <p class="tagline">天草で住宅・不動産を探すなら</p>
      <h1>
        <router-link to="/">
          <img src="@/assets/images/common/logo.svg" alt="ナガイホーム" />
        </router-link>
      </h1>
    </div>
    <div class="header-contact">
      <h4>
        <img
          src="@/assets/images/common/kengakukai.svg"
          alt="見学会随時実施中"
        />
      </h4>
      <div class="header-contact-tel">
        <p>お電話にて見学をご予約いただけます</p>
        <p class="tel">0969-23-7101</p>
        <p class="opentime">受付時間 10:00~17:00</p>
      </div>
      <a class="telbutton" href="tel:0969237101">
        <svg version="1.1" id="tel" x="0px" y="0px" viewBox="0 0 22.5 29.4">
          <path
            class="st0"
            d="M21.5,24.4l-3-4.6c-0.2-0.3-1.6,0-2.3,0.4c-0.7,0.5-1.4,1.2-1.8,2c-0.7,0.4-1.2,0-2.3-0.5
	C10.6,21,9,19,7.7,17.2c-1.1-1.9-2.3-4.2-2.4-5.7c0-1.3-0.1-1.9,0.5-2.4C6.8,9,7.6,8.7,8.4,8.3c0.7-0.5,1.5-1.6,1.3-2l-3-4.6L5.6,0
	C4.4,0.2,3.1,0.6,2,1.2C0,2.6-0.4,6.7,0.4,10c0.8,3.3,2.1,6.5,4,9.4c1.9,2.8,4.2,5.4,6.9,7.5c2.7,2.1,6.6,3.4,8.7,2.1
	c1-0.8,1.9-1.7,2.6-2.8L21.5,24.4z"
          />
        </svg>
        今すぐお電話
      </a>
      <router-link to="contact" class="contactbtn">
        <svg version="1.1" id="_x32_" x="0px" y="0px" viewBox="0 0 512 512">
          <g>
            <path
              class="st0"
              d="M496.6,68.8H15.4C6.9,68.8,0,75.8,0,84.3v30.4l256,171.5l256-171.6V84.3C512,75.8,505.1,68.8,496.6,68.8z"
            />
            <path
              class="st0"
              d="M0,178v203.4c0,34.1,27.6,61.8,61.8,61.8h388.4c34.1,0,61.8-27.6,61.8-61.8V178L256,349.6L0,178z"
            />
          </g>
        </svg>
        お問い合わせ
      </router-link>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss">
main {
  padding-top: 80px;
  @include tb {
    padding-top: 60px;
  }
}
</style>
<style scoped lang="scss">
header {
  width: 100%;
  height: 80px;
  overflow: hidden;
  background-color: white;
  display: flex;
  position: fixed;
  z-index: 999;
  border-bottom: 1px solid $color_lblue;
  @include tb {
    height: 60px;
  }
  .header-title {
    padding-top: 15px;
    padding-bottom: 10px;
    padding-left: $h-gap;
    .tagline {
      font-size: 0.8rem;
      padding-bottom: 0.25em;
      @include tb {
        font-size: 0.65rem;
      }
    }
    h1 {
      max-width: 210px;
      height: auto;
      transition: 0.2s;
      &:hover {
        opacity: 0.8;
      }
      @include tb {
        width: 140px;
      }
      & > img {
        width: 100%;
        height: auto;
      }
    }
  }
  .header-contact {
    display: flex;
    margin-left: auto;
    h4 {
      margin-top: 15px;
      margin-bottom: 10px;
      margin-left: 8px;
      color: white;
      animation: hovering ease-in-out 1.5s 1s 10;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      @include tb {
        max-width: 90px;
        max-height: 38px;
      }
    }
    .header-contact-tel {
      margin: 15px 1em 10px 0.5em;
      .tel {
        @include din;
        color: $color-blue;
        font-size: 2rem;
        letter-spacing: -0.04em;
      }
      p {
        font-size: 0.6rem;
        text-align: right;
      }
      @include tb {
        display: none;
      }
    }
    .telbutton {
      display: none;

      @include tb {
        flex-shrink: 0;
        background-color: $color-lblue;
        width: clamp(80px, 10vw, 180px);
        color: $color_blue;
        font-size: clamp(0.6rem, 1.2vw, 1rem);
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        svg {
          width: auto;
          height: 3em;
          margin-right: 0;
          margin-bottom: 0.4em;
          fill: $color_blue;
          padding-bottom: 0.5em;
        }
      }
    }
    .contactbtn {
      flex-shrink: 0;
      background-color: $color-blue;
      width: clamp(80px, 10vw, 180px);
      color: white;
      font-size: clamp(0.6rem, 1.2vw, 1rem);
      font-weight: bold;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: 0.2s;
      svg {
        width: 1.4em;
        height: 1.4em;
        margin-right: 0.25em;
        fill: white;
        padding-bottom: 0.1em;
      }
      &:hover {
        opacity: 0.8;
      }
      @include tb {
        flex-direction: column;
        svg {
          width: auto;
          height: 3em;
          margin-right: 0;
          margin-bottom: 0.4em;
          fill: white;
          padding-bottom: 0.5em;
        }
      }
    }
  }
}
</style>
